import React, { Component } from "react";

class SendChatTranscriptForm extends Component {
    constructor() {
        super();
        this.trancriptRef = React.createRef();
        this.messageRef = React.createRef();
    }
    emailPlaceholderValue = "Enter Email ID";

    render() {
        return (
            <div ref={this.trancriptRef} className="s360-chat-full-screen-container">
                <div className="s360-chat-transcript-email-form-container">
                    <div className="s360-chat-transcript-default-close-icon" onClick={this.props.onClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24.674 24.668"><defs></defs><path class="a" style={{ fill: this.props.config.designDetails.headerColor || "black" }} d="M26.546,23.623l8.813-8.813a2.065,2.065,0,0,0-2.92-2.92L23.625,20.7,14.813,11.89a2.065,2.065,0,1,0-2.92,2.92l8.813,8.813-8.813,8.813a2.065,2.065,0,1,0,2.92,2.92l8.813-8.813,8.813,8.813a2.065,2.065,0,1,0,2.92-2.92Z" transform="translate(-11.285 -11.289)" /></svg>
                    </div>
                    <div className="s360-chat-transcript-email-form-textbox-container" style={this.formInputBoxContainerStyle()} >
                        <input type="text" ref={this.messageRef} className="s360-initial-form-textbox-input" onClick={this.onClickInput} onBlur={this.onInputOut} defaultValue={this.emailPlaceholderValue} style={this.formInputBoxStyle()} />
                    </div>
                    <div className={"s360-chat-transcript-send-button-container"}>
                        <input className="s360-initial-form-start-button" type='button' value='Send' onClick={this.onSend} style={this.buttonStyle()} />
                    </div>
                </div>
            </div>
        )
    }

    onSend = () => {
        if (!this.validate()) { return }
        let emailId = this.messageRef.current.value;
        this.props.onSendChatTranscript(emailId);
    }

    buttonStyle = () => {
        return {
            background: this.props.config.designDetails.selectionButtonColor,
            color: this.props.config.designDetails.selectionButtonTextColor,
            fontFamily:     this.props.config.designDetails.selectionButtonFont,
            fontSize:       this.props.config.designDetails.selectionButtonFontSize+"px",
        }
    }

    formInputBoxContainerStyle = () => {
        return {
            color: this.props.config.designDetails.headerColor,
        }
    }

    formInputBoxStyle = () => {
        return {
            borderColor: this.props.config.designDetails.headerColor,
            color: this.props.config.designDetails.headerColor,
            backgroundColor: this.props.config.designDetails.pageBackgroundColor
        }
    }

    onClickInput = (e) => {
        if (e.target.value === this.emailPlaceholderValue) {
            this.messageRef.current.value = "";
        }
    }

    onInputOut = (e) => {
        if (!e.target.value || !e.target.value.trim) {
            this.messageRef.current.value = this.emailPlaceholderValue;
        }
    };

    value = () => {
        let aValue = {};
        aValue[this.emailPlaceholderValue] = this.messageRef.current.value;
        return aValue;
    };

    validate = () => { return true; }
}

export default SendChatTranscriptForm;